import { useFormContext } from 'react-hook-form';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useEffect } from 'react';

const MIN_LENGTH = 6;

const PasswordTips = ({ name, onChangeValid }) => {
  const { watch } = useFormContext();
  const password = watch(name, '');

  const rules = [
    { label: `Минимум ${MIN_LENGTH} символов`, valid: password.length >= MIN_LENGTH },
    { label: 'Хотя бы одну строчную букву', valid: /[a-zа-яё]/.test(password) },
    { label: 'Хотя бы одну заглавную букву', valid: /[A-ZА-ЯЁ]/.test(password) },
    { label: 'Хотя бы одну цифру', valid: /\d/.test(password) },
    { label: 'Только латинские буквы', valid: !/[а-яёА-ЯЁ]/.test(password) },
  ];

  const isValidPassword = rules.every((rule) => rule.valid);

  useEffect(() => {
    onChangeValid?.(isValidPassword);
  }, [isValidPassword, onChangeValid]);

  return (
    !isValidPassword &&
    password && (
      <div className={'z-10 absolute left-0 opacity-90 top-[70px] bg-white border-b border border-gray-300 rounded-xl p-2 shadow-lg'}>
        <p className={'text-sm text-gray-700 mb-1 font-medium'}>Пароль должен содержать:</p>
        <ul>
          {rules.map((rule, i) => {
            const isValid = rule?.valid;

            return (
              <li key={i} className={`flex gap-x-1 items-center text-xs ${isValid ? 'text-green-700' : 'text-red-600'}`}>
                {isValid ? (
                  <CheckRoundedIcon sx={{ width: 18, height: 18 }} color={'success'} />
                ) : (
                  <CloseRoundedIcon sx={{ width: 18, height: 18 }} color={'error'} />
                )}
                <span>{rule.label}</span>
              </li>
            );
          })}
        </ul>
      </div>
    )
  );
};
export default PasswordTips;
